/**
 * When a vehicle counts as connected.
 *
 * "Connected" means the tracker is powered and in touch — nothing to do with
 * whether the vehicle is moving. An ambulance idling at a hospital gate is
 * connected; one switched off, or parked where there is no GSM coverage, is
 * not, until its signal returns and a fix arrives.
 *
 * This must match the server's VEHICLE_ONLINE_THRESHOLD_MIN. The map used to
 * carry its own 60-second threshold, so a running-but-stationary vehicle that
 * missed a single report flipped to offline there while the dashboard still
 * showed it connected. One number, one meaning, everywhere.
 *
 * Five minutes rather than one: a tracker reports every ~30 seconds while
 * running, so a minute-wide window turns one lost packet into a false
 * disconnection.
 */
export const VEHICLE_ONLINE_THRESHOLD_MS = 5 * 60_000;

/** Fresh enough to count as connected. Guards against clocks running ahead. */
export const isFresh = (timestamp?: string | Date | null): boolean => {
  if (!timestamp) return false;
  const t = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  if (!Number.isFinite(t)) return false;
  const delta = Date.now() - t;
  return delta < VEHICLE_ONLINE_THRESHOLD_MS && delta > -VEHICLE_ONLINE_THRESHOLD_MS;
};

export const CONNECTION_LABELS = {
  online: 'متصلة',
  offline: 'غير متصلة',
} as const;
